import { render, staticRenderFns } from "./after_saleService.vue?vue&type=template&id=522b3812&scoped=true&"
import script from "./after_saleService.vue?vue&type=script&lang=js&"
export * from "./after_saleService.vue?vue&type=script&lang=js&"
import style0 from "./after_saleService.vue?vue&type=style&index=0&id=522b3812&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522b3812",
  null
  
)

export default component.exports